import queryString from 'query-string';
import { NavigateFunction } from 'react-router-dom';

export const navigate = (
  navigator: NavigateFunction,
  path: string,
  // TODO: limit to explicitly declared queryParams
  queryParams: Record<string, any>,
  replace = false,
): void => {
  // console.log('navigate ran', queryParams);
  if (replace) {
    navigator(`${path}?${queryString.stringify(queryParams)}`, {
      replace: true,
    });
  } else {
    navigator(`${path}?${queryString.stringify(queryParams)}`);
  }
};
